import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const redeemDependentInvite = inviteCode =>
  call(websocketFetch, 'redeem_dependent_invite', { invite_code: inviteCode });
